import debounce from 'lodash/debounce';

export const applySearch = debounce(
  (val: string | boolean | undefined, cb: any) => {
    cb(val);
  },
  300
);
